import React from 'react';
import ConfiguratorOption from '../ConfiguratorOption';

interface ProductCoveringProps {
  selectedProduct: string;
  onSelectProduct: (product: string) => void;
}

const ProductCovering: React.FC<ProductCoveringProps> = ({ selectedProduct, onSelectProduct }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-2 gap-y-2 w-full">

      <ConfiguratorOption
        title="Polycarbonat klar"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/Polycarbonatklar.webp`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/Polycarbonatklar.webp`}
        onClick={() => onSelectProduct("Polycarbonat klar")}
        isSelected={selectedProduct === "Polycarbonat klar"}
        isCustomBorder={true}
      />
      <ConfiguratorOption
        title="Polycarbonat opal"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/PolycarbonatOpal.webp`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/PolycarbonatOpal.webp`}
        onClick={() => onSelectProduct("Polycarbonat opal")}
        isSelected={selectedProduct === "Polycarbonat opal"}
        isCustomBorder={true}

      />
      <ConfiguratorOption
        title="VSG (Verbundsicherheitsglas) klar"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/VSGklar.webp`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/VSGklar.webp`}
        onClick={() => onSelectProduct("VSG (Verbundsicherheitsglas) klar")}
        isSelected={selectedProduct === "VSG (Verbundsicherheitsglas) klar"}
        isCustomBorder={true}

      />
      <ConfiguratorOption
        title="VSG (Verbundsicherheitsglas) opal"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/VSGOpal.webp`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/webp/VSGOpal.webp`}
        onClick={() => onSelectProduct("VSG (Verbundsicherheitsglas) opal")}
        isSelected={selectedProduct === "VSG (Verbundsicherheitsglas) opal"}
        isCustomBorder={true}

      />
    </div>
  );
};

export default ProductCovering;
